import React from 'react';
import { Col, Row } from 'components/common/grid';
import { FormattedMessage } from 'react-intl';
import styled from 'types/theme.types';
import Button from 'components/common/button';
import type { UseFormReturnType } from 'hooks/use-form.hook';

import type { VcsConnection } from './vcs-connection-modal-picker';

export const VcsConnectionModalButtons: React.FC<{
  form: UseFormReturnType;
  vcsConnection: VcsConnection;
  onSave: () => void;
}> = ({ form, onSave }) => {
  return (
    <Row gutter={8}>
      <Col span={6}>
        <ButtonStyled
          data-e2e="save-vcs-connection-button"
          isLoading={form.isSubmitting}
          type="primary"
          onClick={async () => {
            await form.submit();
            onSave();
          }}
          disabled={!form.canSave || form.isSubmitting}>
          <ButtonContainer>
            <FormattedMessage id="organization.settings.agents.vcs-connections-modal.save-button" />
          </ButtonContainer>
        </ButtonStyled>
      </Col>
    </Row>
  );
};

const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
`;

const ButtonStyled = styled(Button)`
  width: 100%;
`;
